import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import moment from "moment/moment";
import { Loading } from "../../../Other/Loading";

const UpcomingWebinar = () => {
  const [webinar, setWebinar] = useState([]);
  const [loading, setLoading] = useState(true);
  const now = new Date();

  const firstDay = moment(
    new Date(now.getFullYear(), now.getMonth(), 1)
  ).format("YYYY MM,DD");
  const lastDay = moment(
    new Date(now.getFullYear(), now.getMonth() + 1, 0)
  ).format("YYYY MM,DD");
  
  useEffect(() => {
    const fetchWebinars = async () => {
      try {
        const response = await axiosInstance.get(`webinar/all?startDate=${firstDay}&endDate=${lastDay}`);
        setWebinar(response.data.data);
      } catch (err) {
        console.error("Error fetching webinars:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchWebinars();
  }, []);


  function eventsGetDays() {
    var startDate = moment(now).format("YYYY,MM,DD");
    const webinardata = webinar?.map((ele, items) => {
      var endDate = moment(ele?.webinarDate, "YYYY,MM,DD");
      var result = endDate.diff(startDate, "days");
      return { ...ele, result };
    });
    return webinardata;
  }

  const webinardata = eventsGetDays();

  return (
    <div className="box-shadow-new-01">
      <p className="paragraph-css">Today's or Upcoming Webinar</p>

      <div>
        {loading ? (
          <div style={{ display: "flex", flexDirection: "column", gap: "12px", padding: "10px 0" }}>
            {[...Array(2)].map((_, index) => (
              <div key={index} className="webinar-box" style={{ border: "1px solid #f1f5f9", display: "flex", flexDirection: "column", gap: "10px" }}>
                <span className="skeleton" style={{ width: "120px", height: "16px", borderRadius: "4px" }} />
                <span className="skeleton" style={{ width: "80px", height: "12px", borderRadius: "3px" }} />
                <span className="skeleton" style={{ width: "100px", height: "12px", borderRadius: "3px" }} />
                <span className="skeleton" style={{ width: "60px", height: "30px", borderRadius: "8px", alignSelf: "flex-end" }} />
              </div>
            ))}
          </div>
        ) : webinar?.length === 0 ? (
          <div className="webinar-box">
            {/* <Loading /> */}
            <p className="webinar-text">No Upcoming Webinar</p>
          </div>
        ) : (
          <>
            {webinardata?.map((item, index) => (
              <div key={index} className="webinar-box">
                <p className="webinar-text">{item?.eventName}</p>
                <div className="dashboard-main align-items-center-webinar">
                  <span className="icon icon-reminder width-icons-instructor"></span>
                  <span className="webinar-timing">
                    {item.result} Days Left
                  </span>
                </div>
                <div className="dashboard-main align-items-center-webinar">
                  <span className="icon icon-calendar width-icons-instructor"></span>
                  <div className="dashboard-main align-items-center-webinar">
                    <p className="webinar-timing">
                      {moment(item?.webinarDate).format("DD/MM/YYYY")}
                    </p>
                    <span>|</span>
                    <p className="webinar-timing">{item?.startTime}</p>
                  </div>
                </div>
                <div className="dashboard-main align-items-center-webinar">
                  <span className="icon icon-calendar width-icons-instructor"></span>
                  <p className="webinar-timing">20</p>
                </div>

                <button className="export-btn">Join</button>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default UpcomingWebinar;
